import { Component } from "../../types";
import { WorkspaceType } from "../stores/workspaceStore";

interface OtherDetailsType {
  show_updated_banner: boolean;
  updated_banner_video: string;
}

export const WorkspaceListCtx = {
  workspace: null as null | WorkspaceType,
  editWorkspaceForm: null as null | Component,
  cantDeleteWorkspaceModal: null as null | Component,
  deleteWorkspaceModal: null as null | Component,
  otherDetails: {} as any,

  setWorkspace(workspace: WorkspaceType | null) {
    workspace = workspace;
  },
  setEditWorkspaceForm(form: Component | null) {
    this.editWorkspaceForm = form;
  },
  setCantDeleteWorkspaceModal(modalComponent: Component | null) {
    this.cantDeleteWorkspaceModal = modalComponent;
  },
  setDeleteWorkspaceModal(modalComponent: Component | null) {
    this.deleteWorkspaceModal = modalComponent;
  },
  setOtherDetails(otherDetails: OtherDetailsType) {
    this.otherDetails = otherDetails;
  },
};